// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"100e5942","455":"72298bb3","488":"bf8fb780","977":"7c6a4c50"}[chunkId] + ".chunk.js";
};